import React, { createContext, useContext, useState, useEffect } from 'react';

const FeatureGateContext = createContext(null);

// Module-level handler — axiosInstance (non-React module) calls this
let _triggerHandler = null;

export const setFeatureGateHandler = (handler) => {
	_triggerHandler = handler;
};

export const triggerFeatureGate = (errorData) => {
	if (_triggerHandler) {
		_triggerHandler(errorData);
	}
};

export const FeatureGateProvider = ({ children }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [errorData, setErrorData] = useState(null);

	useEffect(() => {
		setFeatureGateHandler((data) => {
			setErrorData(data);
			setIsOpen(true);
		});
		return () => setFeatureGateHandler(null);
	}, []);

	const close = () => {
		setIsOpen(false);
		setErrorData(null);
	};

	return (
		<FeatureGateContext.Provider value={{ isOpen, errorData, close }}>
			{children}
		</FeatureGateContext.Provider>
	);
};

export const useFeatureGate = () => useContext(FeatureGateContext);
